import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tagon",
  "use": "tagon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"tagon\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 128a384 384 0 1 1 0 768A384 384 0 0 1 512 128z m0 64a320 320 0 1 0 0 640A320 320 0 0 0 512 192z\" fill=\"#1296db\" p-id=\"3380\" /><path d=\"M512 512m-192 0a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z\" fill=\"#1296db\" p-id=\"3381\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol